import { useAppSelector } from "../../hooks/StoreHooks";
import { ShopModule } from "../../types/shopModuleTypes";

export const useShopModules = (): ShopModule[] =>
    useAppSelector((state) => state.shopModules.shopModules);

export const useShopModuleById = (id: number): ShopModule | undefined =>
    useAppSelector((state) =>
        state.shopModules.shopModules.find((module) => module.id === id)
    );

export const useShopModuleIdTypePairs = () =>
    useAppSelector((state) =>
        state.shopModules.shopModules.map(({ id, type }) => ({ id, type }))
    );